import { render, staticRenderFns } from "./DebugHome.vue?vue&type=template&id=e9130ddc&scoped=true&lang=pug"
import script from "./DebugHome.vue?vue&type=script&lang=ts"
export * from "./DebugHome.vue?vue&type=script&lang=ts"
import style0 from "./DebugHome.vue?vue&type=style&index=0&id=e9130ddc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9130ddc",
  null
  
)

export default component.exports